/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
require('./src/styles.css');
const { defaultPluginOptions } = require('./src/plugin-options');
const { onAdaReady, setVisible, setZIndex } = require('./src/index');
const { createDismissButton, isAdaDismissed } = require('./src/dismiss-button');
const { chatChange } = require('./src/chat-window');

exports.onClientEntry = (_, options = {}) => {
  const pluginOptions = {
    ...defaultPluginOptions,
    ...options
  };

  if (window.adaEmbed) {
    window.adaEmbed.start({
      crossWindowPersistence: true,
      ...pluginOptions.adaSettings,
      toggleCallback: chatChange,
      handle: pluginOptions.handle,
      adaReadyCallback: () => {
        try {
          if (pluginOptions.dismissButton !== false) createDismissButton(pluginOptions);
          if (pluginOptions.zIndex) setZIndex(pluginOptions.zIndex);

          setTimeout(() => {
            if (!isAdaDismissed(pluginOptions)) setVisible(true);
          }, pluginOptions.delay);

          onAdaReady();
        } catch(e) {
          console.warn(`Failed to configure ADA chatbot: ${e}`);
        }
    }});
  }
};
